import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMonitor = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 1.25,
			y: 1.875,
			width: 12.5,
			height: 8.75,
			rx: 1.25,
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.5 10.625V13.125",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 13.125H10",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgMonitor;
